import i18n from '@/i18n';
import { authSessionEvents } from '@/services/api/auth-session-events';
import { toastService } from '@/services/notifications/toast.service';
import { store } from '@/store/store';
import { clearCredentials } from '@/store/slices/auth.slice';

let isRegistered = false;

export function registerSessionListeners(): void {
  if (isRegistered) {
    return;
  }

  isRegistered = true;

  authSessionEvents.onUnauthorized(() => {
    const wasAuthenticated = store.getState().auth.isAuthenticated;
    store.dispatch(clearCredentials());

    if (wasAuthenticated) {
      toastService.error(i18n.t('auth.sessionExpired'));
    }
  });

  authSessionEvents.onForbidden(() => {
    toastService.error(i18n.t('auth.forbiddenAction'));
  });
}
